// src/utils/parseUserAgent.ts
// Hand-rolled, not a dependency — mirrors backend/src/utils/requestContext.ts's
// parseUserAgent; only needs to be readable in the Audit Log / Sessions UI,
// not a precise UA parse.
export function parseUserAgent(ua?: string): string {
  if (!ua) return 'Unknown device';

  let browser = 'Unknown browser';
  if (ua.includes('Edg/')) browser = 'Edge';
  else if (ua.includes('Chrome/') && !ua.includes('Chromium')) browser = 'Chrome';
  else if (ua.includes('Firefox/')) browser = 'Firefox';
  else if (ua.includes('Safari/') && !ua.includes('Chrome')) browser = 'Safari';

  let os = 'Unknown OS';
  if (ua.includes('Windows')) os = 'Windows';
  else if (ua.includes('Mac OS')) os = 'macOS';
  else if (ua.includes('Android')) os = 'Android';
  else if (ua.includes('iPhone') || ua.includes('iPad')) os = 'iOS';
  else if (ua.includes('Linux')) os = 'Linux';

  return `${browser} on ${os}`;
}
